function ClearIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.75 3a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5H.75zM3 7.75A.75.75 0 013.75 7h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 013 7.75zm3 4a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75z"
                clipRule="evenodd"
            ></path>
            <path
                fill="currentColor"
                d="M14.914 2.336a.75.75 0 00-1.28-.53l-.884.884-.884-.884a.75.75 0 10-1.06 1.06l.883.884-.883.884a.75.75 0 101.06 1.061l.884-.884.884.884a.75.75 0 101.06-1.06l-.883-.885.883-.883a.75.75 0 00.22-.53z"
            ></path>
        </svg>
    )
}

export default ClearIcon
